/** @format */

import { memo } from 'react'

import styles from 'dir/styles/courses.module.css'

export const _3 = memo(() => (
  <section className={styles.section}>
    <h2 className={styles.h2}>3 - Пример</h2>
    <p className={styles.description}>В интерактивном редакторе можно посмотреть код и живую версию таймера. </p>
    <iframe
      height="300"
      scrolling="no"
      title="rotman_redux_2_3"
      src="https://codesandbox.io/embed/timer-with-redux-toolkit-sze3f?autoresize=1&fontsize=14&hidenavigation=1&view=editor"
      frameBorder="no"
      loading="lazy"
      allowTransparency="true"
      allowFullScreen="true"
    />
  </section>
))
